import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import {
  getCaseThunk,
  getActivityDetailsThunk,
  saveOrUpdateActivityDetailsThunk,
} from "./thunk";

const getCaseInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const getActivityDetailsInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const saveOrUpdateActivityDetailsInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const getCaseSlice = createSlice({
  name: "getCase",
  initialState: getCaseInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getCaseThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getCaseThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const getActivityDetailsSlice = createSlice({
  name: "getActivityDetails",
  initialState: getActivityDetailsInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityDetailsThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getActivityDetailsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getActivityDetailsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const saveOrUpdateActivityDetailsSlice = createSlice({
  name: "saveOrUpdateActivityDetails",
  initialState: saveOrUpdateActivityDetailsInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveOrUpdateActivityDetailsThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(saveOrUpdateActivityDetailsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(saveOrUpdateActivityDetailsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetGetCase } = getCaseSlice.actions;
export const { reset: resetGetActivityDetails } =
  getActivityDetailsSlice.actions;
export const { reset: resetSaveOrUpdateActivityDetails } =
  saveOrUpdateActivityDetailsSlice.actions;
const reducers = combineReducers({
  getActivityDetails: getActivityDetailsSlice.reducer,
  getCase: getCaseSlice.reducer,
  saveOrUpdateActivityDetails: saveOrUpdateActivityDetailsSlice.reducer,
});

export default reducers;
